import { render, staticRenderFns } from "./DashboardCreator.vue?vue&type=template&id=4f7e37c2&scoped=true&"
import script from "./DashboardCreator.vue?vue&type=script&lang=js&"
export * from "./DashboardCreator.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCreator.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DashboardCreator.vue?vue&type=style&index=1&id=4f7e37c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7e37c2",
  null
  
)

export default component.exports